module.exports = __webpack_public_path__ + "static/media/08.d833407b.mp3";